<template>
    <div style="width: 100%; height: 350px;">
        <div id="stagemain" style="width: 100%; height: 100%;"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts'
import Http from '../../src/apis/teach'

export default {
    name: 'stageChartLeftComponent',
    props: {
        form: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            myChart: null,
            resizeHandler: null
        }
    },
    
    mounted() {
        this.$nextTick(() => {
            this.initChart();
        });
        
        this.resizeHandler = () => {
            if (this.myChart) {
                this.myChart.resize();
            }
        };
        window.addEventListener('resize', this.resizeHandler);
        this.workLineChart()
    },
    
    beforeDestroy() {
        window.removeEventListener('resize', this.resizeHandler);
        if (this.myChart) {
            this.myChart.dispose();
            this.myChart = null;
        }
    },
    watch: {
        form: {
            handler(newVal) {
                this.workLineChart()
            },
            deep: true  // 深度监听对象内部属性变化
        }
    },
    methods: {
        workLineChart(){

            Http.getStagePlanStageChart(this.form).then((res) => {
                this.initChart(res.data)
            });
            

            
        },
        initChart(data) {
            if (this.myChart) {
                this.myChart.dispose();
            }

            const chartDom = document.getElementById('stagemain');
            if (!chartDom) {
                console.error('未找到图表容器');
                return;
            }

            this.myChart = echarts.init(chartDom);

            // 处理数据为空的情况
            const dates = data?.dates || [];
            const counts = data?.counts || [];

            const option = {
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    show: true,
                    backgroundColor: 'rgba(0,0,0,0.7)',
                    textStyle: { color: '#fff' }
                },
                xAxis: {
                    type: 'category',
                    data: dates
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    type: 'line',
                    data: counts,
                    symbol: 'circle',
                    symbolSize: 6
                }]
            };

            this.myChart.setOption(option);
        }
    }
};
</script>